(function () {
  var FOCUSABLE = 'a[href], button, input, select, textarea, [tabindex]';
  var CELLS = '.flickity-slider > *';

  function setHidden(cell, hidden) {
    var els = Array.prototype.slice.call(cell.querySelectorAll(FOCUSABLE));
    if (cell.matches(FOCUSABLE)) els.unshift(cell);
    els.forEach(function (el) {
      if (hidden) {
        if (!el.hasAttribute('data-a11y-tabindex')) {
          el.setAttribute('data-a11y-tabindex', el.hasAttribute('tabindex') ? el.getAttribute('tabindex') : 'none');
          el.setAttribute('tabindex', '-1');
        }
      } else if (el.hasAttribute('data-a11y-tabindex')) {
        var original = el.getAttribute('data-a11y-tabindex');
        if (original === 'none') el.removeAttribute('tabindex'); else el.setAttribute('tabindex', original);
        el.removeAttribute('data-a11y-tabindex');
      }
    });
  }

  function fixCarouselLists() {
    document.querySelectorAll('ul.flickity-enabled, ol.flickity-enabled').forEach(function (list) {
      var slider = list.querySelector('.flickity-slider');
      if (!slider) return;
      list.setAttribute('role', 'none');
      slider.setAttribute('role', 'list');
    });
  }

  // Runs on every mutation (no delay) so scanners never see the unlabelled Slick markup.
  function fixSlick() {
    // Blog posts without gallery images still get an empty slider; a listbox with no options is invalid.
    document.querySelectorAll('.slick-track[role="listbox"]').forEach(function (track) {
      if (!track.children.length) {
        track.removeAttribute('role');
        track.removeAttribute('aria-label');
      }
    });
    document.querySelectorAll('.slick-track[role="listbox"]:not([aria-label])').forEach(function (track) {
      var label = 'Gallery images';
      if (track.closest('[data-gallery-viewer]')) label = 'Product images';
      else if (track.closest('.product-gallery--navigation')) label = 'Product image thumbnails';
      track.setAttribute('aria-label', label);
    });
    // Slick points slides at its dot ids; with dots off those ids don't exist.
    document.querySelectorAll('.slick-slide[aria-describedby]').forEach(function (slide) {
      if (!document.getElementById(slide.getAttribute('aria-describedby'))) slide.removeAttribute('aria-describedby');
    });
  }

  // YouTube/Vimeo embeds (sections and blog content) need a title for screen readers.
  function titleVideos() {
    var frames = document.querySelectorAll('iframe[src*="youtube"]:not([title]), iframe[src*="vimeo"]:not([title])');
    if (!frames.length) return;
    var heading = document.querySelector('h1');
    var name = heading ? heading.textContent.trim() : document.title.split(' — ')[0];
    frames.forEach(function (frame, i) {
      frame.setAttribute('title', 'Video: ' + name + (frames.length > 1 ? ' (' + (i + 1) + ')' : ''));
    });
  }

  function sync() {
    document.querySelectorAll(CELLS).forEach(function (cell) {
      setHidden(cell, cell.getAttribute('aria-hidden') === 'true');
    });
    document.querySelectorAll('[data-blog-posts]:not(.flickity-enabled) > [aria-hidden="true"]').forEach(function (item) {
      item.removeAttribute('aria-hidden');
    });
    fixCarouselLists();
    titleVideos();
  }

  var timer = null;
  function schedule() { clearTimeout(timer); timer = setTimeout(sync, 50); }

  new MutationObserver(function () { fixSlick(); schedule(); }).observe(document.body, {
    subtree: true, childList: true, attributes: true,
    attributeFilter: ['aria-hidden', 'class', 'role', 'aria-describedby']
  });
  fixSlick();
  schedule();
})();